import styled from 'styled-components';

// Fills the block with a legacy gadget's content, as a chart does. Gadgets
// in unselected blocks ignore the pointer, like charts (StudioChart).
const LegacyGadgetBody = styled.div<{ $isInteractive: boolean }>`
  position: relative;
  isolation: isolate;
  flex: 1;
  min-height: 0;

  > div {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    pointer-events: ${(props) => (props.$isInteractive ? 'auto' : 'none')};
  }
`;

export default LegacyGadgetBody;
